"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const react_helmet_1 = require("react-helmet");
const mui_1 = require("tss-react/mui");
const react_device_detect_1 = require("react-device-detect");
const react_router_1 = require("react-router");
const react_use_1 = require("react-use");
const react_redux_1 = require("react-redux");
const immutable_1 = require("immutable");
const Grid_1 = __importDefault(require("@mui/material/Grid"));
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const RefreshRounded_1 = __importDefault(require("@mui/icons-material/RefreshRounded"));
const CircularProgress_1 = __importDefault(require("@mui/material/CircularProgress"));
const Tooltip_1 = __importDefault(require("@mui/material/Tooltip"));
const InfoOutlined_1 = __importDefault(require("@mui/icons-material/InfoOutlined"));
const core_1 = require("companion-app-components/utils/core");
const accounts_1 = require("companion-app-components/flux/accounts");
const feature_flags_1 = require("companion-app-components/flux/feature-flags");
const budgetsSelectors = __importStar(require("companion-app-components/flux/budgets/budgetsSelectors"));
const actions_1 = require("companion-app-components/flux/investmentHoldings/actions");
const selectors_1 = require("companion-app-components/flux/investmentHoldings/selectors");
const selectors_2 = require("companion-app-components/flux/investmentHoldingList/selectors");
const actions_2 = require("companion-app-components/flux/preferences/actions");
const selectors_3 = require("companion-app-components/flux/preferences/selectors");
const entitlements_1 = require("companion-app-components/flux/entitlements");
const auth_1 = require("companion-app-components/flux/auth");
const accountGroupsSelectors_1 = require("companion-app-components/flux/account-groups/accountGroupsSelectors");
const accountsSelectors_1 = require("companion-app-components/flux/accounts/accountsSelectors");
const QMenu_1 = __importDefault(require("components/QMenu"));
const ErrorBoundary_1 = __importDefault(require("components/ErrorBoundary"));
const useQPreferences_1 = __importDefault(require("components/QPreferences/useQPreferences"));
const Footer_1 = __importDefault(require("containers/OverviewPage/components/Footer"));
const constants_1 = require("data/accounts/constants");
const config_1 = require("./config");
const utils_1 = require("./utils");
const TopHoldings_1 = __importDefault(require("./components/TopHoldings"));
const Transactions_1 = __importDefault(require("./components/Transactions"));
const OverviewCard_1 = __importDefault(require("./components/OverviewCard"));
const CalendarCard_1 = __importDefault(require("./components/CalendarCard"));
const BudgetOverview_1 = __importDefault(require("./components/BudgetOverview"));
const SpendingByMonth_1 = __importDefault(require("./components/SpendingByMonth"));
const SpendingByPayee_1 = __importDefault(require("./components/SpendingByPayee"));
const InvestmentSummary_1 = __importDefault(require("./components/InvestmentSummary"));
const NetIncomeOverview_1 = __importDefault(require("./components/NetIncomeOverview"));
const SpendingByCategory_1 = __importDefault(require("./components/SpendingByCategory"));
const style_1 = require("./style");
const log = (0, core_1.getLogger)('containers/OverviewPage/index.ts');
const sessionLayout = config_1.overviewLayout;
const cardRecord = (0, immutable_1.Record)({ key: undefined, value: false });
const useStyles = (0, mui_1.makeStyles)()(style_1.styles);
const OverviewPage = () => {
    var _a, _b;
    const { classes, theme } = useStyles();
    const { datasetPreferences, setDatasetPreference } = (0, useQPreferences_1.default)();
    const preferences = (0, react_redux_1.useSelector)((state) => (0, selectors_3.getPreferences)(state));
    const sharedDatasetPreferences = preferences && preferences.shared.dataset;
    const lastViewedBudgetId = sharedDatasetPreferences && sharedDatasetPreferences.budgetOptions && sharedDatasetPreferences.budgetOptions.lastViewedBudgetId;
    const budgets = (0, react_redux_1.useSelector)((state) => budgetsSelectors.getBudgets(state));
    const budget = (0, react_redux_1.useSelector)((state) => budgetsSelectors.getBudgetById(state, lastViewedBudgetId) || (budgets && budgets.first()));
    const investmentAccounts = (0, react_redux_1.useSelector)((state) => accounts_1.accountsSelectors.getInvestmentAccounts(state));
    const summarizedInvestmentData = (0, react_redux_1.useSelector)((state) => (0, selectors_2.getSummarizedInvestmentData)(state, { accountIds: null }));
    const featureFlags = (0, react_redux_1.useSelector)((state) => feature_flags_1.featureFlagsSelectors.getFeatureFlags(state));
    const isV2QuotesEnabled = (0, react_redux_1.useSelector)((state) => (0, selectors_3.isRealTimeQuotesEnabled)(state));
    const isQuotesLoading = (0, react_redux_1.useSelector)((state) => (0, selectors_1.getIsQuotesLoading)(state));
    const hasReportableAccounts = (0, react_redux_1.useSelector)((state) => accounts_1.accountsSelectors.getHasReportableAccounts(state));
    const tier = (0, react_redux_1.useSelector)((state) => entitlements_1.entitlementsSelectors.getTopTierEntitlement(state));
    const isWebFirstDataset = (0, react_redux_1.useSelector)((state) => auth_1.authSelectors.getIsWebfirstDataset(state));
    const isEntityShareEnableUser = (0, react_redux_1.useSelector)(accountGroupsSelectors_1.isEntityShareUser);
    const accountTypes = (0, react_redux_1.useSelector)(accountsSelectors_1.getAccountTypes);
    const { isOnlyInvestment, isOnlyBank } = (0, utils_1.getEntityShareFlags)(isEntityShareEnableUser, accountTypes, constants_1.BANKING_ACCOUNT_TYPES);
    const hasInvestmentAccounts = investmentAccounts && investmentAccounts.size > 0;
    const todaysInvestmentChangePercent = summarizedInvestmentData ? summarizedInvestmentData.todaysChangePercent : 0;
    const throwJSExceptionForTesting = window.location.href.indexOf('jsexception') !== -1;
    const throwREACTExceptionForTesting = window.location.href.indexOf('reactexception') !== -1;
    const budgetsEnabled = featureFlags.get('budgets');
    const configureDash = featureFlags.get('configureDashboard');
    const incomeEnabled = featureFlags.get('netIncomeCard');
    const investmentSummaryEnabled = featureFlags.get('investmentSummaryCard');
    const investmentMoversEnabled = featureFlags.get('investmentTopMoversCard');
    const spendingEnabled = featureFlags.get('spending');
    const reportsEnabled = featureFlags.get('reports');
    const checkPrefs = (0, react_1.useCallback)((isFirstRender) => {
        const { changed, layout } = (0, utils_1.normalizeOverviewPageLayout)({
            prefLayout: datasetPreferences.overviewPageLayout,
            defaultLayout: config_1.overviewLayout,
            createCardRecord: (card) => cardRecord(card),
        });
        if (changed && !isFirstRender) {
            if (layout.size !== datasetPreferences.overviewPageLayout.size) {
                log.log('normalized overview page layout');
            }
            setDatasetPreference({ overviewPageLayout: layout });
        }
        return layout;
    }, [datasetPreferences, setDatasetPreference]);
    const getFilteredLayout = (0, react_1.useCallback)((filteredLayout) => ((0, utils_1.filterOverviewLayout)({
        filteredLayout,
        overviewLayoutEntity: config_1.overviewLayoutEntity,
        isEntityShareEnableUser,
        isOnlyBank,
        isOnlyInvestment,
    })), [isEntityShareEnableUser, isOnlyBank, isOnlyInvestment]);
    const [overviewPageLayout, setOverviewPageLayout] = (0, react_1.useState)(getFilteredLayout(checkPrefs(true)));
    const [forceUpdate, setForceUpdate] = (0, react_1.useState)(false);
    const prevOverviewPageLayoutRef = (0, react_1.useRef)(datasetPreferences.overviewPageLayout);
    const preAccountTypes = (0, react_1.useRef)(accountTypes);
    const navigate = (0, react_router_1.useNavigate)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const resizeListener = () => setTimeout(() => setForceUpdate(!forceUpdate), 66);
    (0, react_use_1.useEffectOnce)(() => {
        // This is done so that when the overview page layout is set to default, we add the correct values to the layout in the correct form
        if (datasetPreferences && datasetPreferences.overviewPageLayout.size > 0 && overviewPageLayout.isEmpty()) {
            setOverviewPageLayout(getFilteredLayout(checkPrefs(false)));
        }
        window.addEventListener('resize', resizeListener);
        // if the version of the layout has changed, we reset the dashboard page (sorry folks)
        if ((datasetPreferences === null || datasetPreferences === void 0 ? void 0 : datasetPreferences.overviewLayoutVersion) && ((datasetPreferences === null || datasetPreferences === void 0 ? void 0 : datasetPreferences.overviewLayoutVersion) !== config_1.overviewLayoutVersion)) {
            setDatasetPreference({ overviewLayoutVersion: config_1.overviewLayoutVersion, overviewPageLayout: (0, immutable_1.List)(config_1.overviewLayout) });
        }
    });
    (0, react_1.useEffect)(() => {
        if (datasetPreferences.overviewPageLayout
            && (datasetPreferences.overviewPageLayout !== prevOverviewPageLayoutRef.current || preAccountTypes.current !== accountTypes)) {
            // This is done so that on dataset change, we check preferences
            setOverviewPageLayout(getFilteredLayout(checkPrefs(false)));
            prevOverviewPageLayoutRef.current = datasetPreferences.overviewPageLayout;
            preAccountTypes.current = accountTypes;
        }
    }, [datasetPreferences, checkPrefs, isEntityShareEnableUser, accountTypes, getFilteredLayout]);
    (0, react_use_1.useUnmount)(() => {
        window.removeEventListener('resize', resizeListener);
    });
    const handleBudgetChange = (event) => {
        if (event.target && event.target.value) {
            dispatch((0, actions_2.setPreference)({
                section: 'shared',
                group: 'dataset',
                preference: {
                    budgetOptions: {
                        lastViewedBudgetId: event.target.value,
                    },
                },
            }));
            core_1.tracker.track(core_1.tracker.events.budgetChange, { type: 'budget' });
            setForceUpdate(!forceUpdate);
        }
    };
    const hanldeQuotesRefreshAction = (e) => {
        e.stopPropagation();
        dispatch((0, actions_1.getInvestmentQuotes)());
    };
    const refreshQuotesAction = () => (isV2QuotesEnabled &&
        <IconButton_1.default tabIndex={0} aria-label="Refresh Quotes" onClick={hanldeQuotesRefreshAction} size="large">
      {isQuotesLoading ? <CircularProgress_1.default color="inherit" size={20}/> : <RefreshRounded_1.default color="primary"/>}
    </IconButton_1.default>);
    const lastSyncId = (_a = sharedDatasetPreferences === null || sharedDatasetPreferences === void 0 ? void 0 : sharedDatasetPreferences.syncId) === null || _a === void 0 ? void 0 : _a.lastSyncId;
    const { canShowSyncNotice, highlightSyncNotice, lastSyncLabel, shouldShowSyncNotice, } = (0, utils_1.getSyncNoticeState)({
        lastSyncId,
        isWebFirstDataset,
        showLastDesktopSyncInfo: datasetPreferences === null || datasetPreferences === void 0 ? void 0 : datasetPreferences.showLastDesktopSyncInfo,
    });
    const isStarterUser = () => { var _a; return ['US_QUICKEN_STARTER', 'CA_QUICKEN_CASHMANAGER'].includes((_a = tier === null || tier === void 0 ? void 0 : tier.id) !== null && _a !== void 0 ? _a : ''); };
    const reorderCards = (fromCard, toCard, save) => {
        if (isEntityShareEnableUser) {
            return;
        }
        const currentLayout = overviewPageLayout; // datasetPreferences.overviewPageLayout;
        const cardsPerRow = (0, utils_1.computeCardsPerRow)(window.innerWidth, theme.breakpoints.values);
        const newList = (0, utils_1.reorderOverviewLayout)({
            currentLayout,
            fromCard,
            toCard,
            cardsPerRow,
            overviewCards: config_1.overviewCards,
        });
        if (newList !== currentLayout) {
            setOverviewPageLayout(getFilteredLayout(newList));
        }
        if (save) {
            setDatasetPreference({ overviewPageLayout: newList });
        }
    };
    const renderOverviewCardInternal = (cardObj, cardId) => {
        const zeroStateWithAction = {
            primaryText: "You don't have any upcoming transactions.",
            secondaryText: 'Click here to add your income and bills.',
        };
        switch (cardObj.name) {
            /*---------------------------------*/
            /* RECENT TRANSACTIONS             */
            /*---------------------------------*/
            case 'transactions':
                return (<OverviewCard_1.default id="recent-transactions-card" title="RECENT TRANSACTIONS" isHeaderClickable={hasReportableAccounts} {...hasReportableAccounts && { titleNav: () => navigate(cardObj.titleNav) }} reorderCards={reorderCards} cardId={cardId}>
            <Transactions_1.default txnsToShow={cardObj.name}/>
          </OverviewCard_1.default>);
            /*---------------------------------*/
            /* UPCOMING TRANSACTIONS COMPANION */
            /*---------------------------------*/
            case 'upcoming':
                return (<OverviewCard_1.default id="upcoming-transactions-card" title="UPCOMING" isHeaderClickable={hasReportableAccounts} {...hasReportableAccounts && { titleNav: () => navigate(cardObj.titleNav) }} reorderCards={reorderCards} cardId={cardId}>
            <Transactions_1.default txnsToShow={cardObj.name} zeroStateWithAction={zeroStateWithAction}/>
          </OverviewCard_1.default>);
            /*---------------------------------*/
            /* SPENDING CATEGORIES             */
            /*---------------------------------*/
            case 'spendingCats':
                if (spendingEnabled || reportsEnabled) {
                    const pieChartStyle = { height: 244, overflow: 'hidden', marginBottom: 24 };
                    return (<OverviewCard_1.default id="spending-card" title={'TOP SPENDING CATEGORIES MONTH TO DATE'} subheader={''} isHeaderClickable={hasReportableAccounts} {...hasReportableAccounts && { titleNav: () => navigate(cardObj.titleNav) }} reorderCards={reorderCards} cardId={cardId}>
              <div id={'piechart-div'} style={pieChartStyle}>
                <SpendingByCategory_1.default />
              </div>
            </OverviewCard_1.default>);
                }
                break;
            /*---------------------------------*/
            /* BUDGETS                         */
            /*---------------------------------*/
            case 'budgets':
                if (budgetsEnabled) {
                    return (<OverviewCard_1.default id="budgets-card" title={budgets && budgets.size ?
                            `${budgets.size > 1 ? 'BUDGETS' : 'BUDGET'} - ${(new Date()).toLocaleString('en-us', {
                                month: 'long',
                                year: 'numeric',
                            }).toUpperCase()}`
                            :
                                'BUDGET'} isHeaderClickable={hasReportableAccounts} {...hasReportableAccounts && { titleNav: () => navigate(`${cardObj.titleNav}?ref=dashboard`) }} reorderCards={reorderCards} cardId={cardId}>
              <BudgetOverview_1.default budgets={budgets && budgets.sortBy((theBudget) => theBudget.name)} budget={budget} budgetChangeHandler={handleBudgetChange}/>
            </OverviewCard_1.default>);
                }
                break;
            /*---------------------------------*/
            /* SPENDING OVER TIME              */
            /*---------------------------------*/
            case 'spendingTime':
                if (spendingEnabled || reportsEnabled) {
                    return (<OverviewCard_1.default id="spending-over-time-card" title={'SPENDING OVER TIME'} subheader={''} isHeaderClickable={hasReportableAccounts} {...hasReportableAccounts && { titleNav: () => navigate(cardObj.titleNav) }} reorderCards={reorderCards} cardId={cardId}>
              {<SpendingByMonth_1.default />}
            </OverviewCard_1.default>);
                }
                break;
            /*---------------------------------*/
            /* INVESTMENT SUMMARY              */
            /*---------------------------------*/
            case 'investments':
                if (investmentSummaryEnabled && !isStarterUser()) {
                    return (<OverviewCard_1.default id="investment-summary-card" title="INVESTMENT SUMMARY" actions={refreshQuotesAction()} isHeaderClickable={hasReportableAccounts} {...hasReportableAccounts && { titleNav: () => navigate(cardObj.titleNav) }} reorderCards={reorderCards} cardId={cardId}>
              <InvestmentSummary_1.default hasInvestmentAccounts={hasInvestmentAccounts}/>
            </OverviewCard_1.default>);
                }
                break;
            /*---------------------------------*/
            /* NET INCOME OVER TIME            */
            /*---------------------------------*/
            case 'netIncome':
                if (incomeEnabled) {
                    return (<OverviewCard_1.default id="net-income-over-time-card" title="NET INCOME OVER TIME" isHeaderClickable={hasReportableAccounts} {...hasReportableAccounts && { titleNav: () => navigate(cardObj.titleNav) }} reorderCards={reorderCards} cardId={cardId}>
              <NetIncomeOverview_1.default />
            </OverviewCard_1.default>);
                }
                break;
            /*---------------------------------*/
            /* INVESTMENT TOP MOVERS           */
            /*---------------------------------*/
            case 'investmentsMovers':
                if (investmentMoversEnabled && !isStarterUser()) {
                    return (<OverviewCard_1.default id="investment-top-movers-card" title="INVESTMENT TOP MOVERS" actions={refreshQuotesAction()} isHeaderClickable={hasReportableAccounts} {...hasReportableAccounts && { titleNav: () => navigate(cardObj.titleNav) }} reorderCards={reorderCards} cardId={cardId}>
              <TopHoldings_1.default hasInvestmentAccounts={hasInvestmentAccounts} todaysInvestmentChangePercent={todaysInvestmentChangePercent}/>
            </OverviewCard_1.default>);
                }
                break;
            /*---------------------------------*/
            /* TOP PAYEES                      */
            /*---------------------------------*/
            case 'topPayees':
                return (<OverviewCard_1.default id="top-payees-card" title="TOP PAYEES THIS MONTH" isHeaderClickable {...hasReportableAccounts && { titleNav: () => navigate(cardObj.titleNav) }} reorderCards={reorderCards} cardId={cardId}>
            <SpendingByPayee_1.default />
          </OverviewCard_1.default>);
            case 'calendar':
                return (<OverviewCard_1.default id="calendar-card" title="Calendar" isHeaderClickable={hasReportableAccounts} {...hasReportableAccounts && { titleNav: () => navigate(cardObj.titleNav) }} reorderCards={reorderCards} cardId={cardId} noHeader>
            <CalendarCard_1.default />
          </OverviewCard_1.default>);
            default:
                return null;
        }
        return null;
    };
    const renderOverviewCard = (card) => {
        // If the card object is set to false, return null
        if (!(card === null || card === void 0 ? void 0 : card.value)) {
            return null;
        }
        // here
        const cardObj = config_1.overviewCards[card === null || card === void 0 ? void 0 : card.key];
        if (!cardObj) {
            log.error('Unrecognized card provided ', card);
            return null;
        }
        const renderCard = renderOverviewCardInternal(cardObj, card);
        if (!renderCard) {
            return null;
        }
        const gridPadding = { padding: 8 };
        return (<ErrorBoundary_1.default>
        <Grid_1.default item xs={cardObj.xs} md={cardObj.md} lg={cardObj.lg} xl={cardObj.xl} style={gridPadding}>
          <div className={(0, classnames_1.default)(classes.componentWrapper)} id={cardObj.name}>
            {renderCard}
          </div>
        </Grid_1.default>
      </ErrorBoundary_1.default>);
    };
    const onConfigChange = (cardId) => {
        const currentLayout = overviewPageLayout.toJS(); // datasetPreferences.overviewPageLayout;
        let newList = currentLayout;
        if (cardId === 'resetDefaults') {
            newList = (0, immutable_1.List)(sessionLayout);
            setDatasetPreference({ overviewPageLayout: newList, showLastDesktopSyncInfo: true });
            return;
        }
        if (cardId === 'lastDesktopSyncInfo') {
            const syncNoticeEnabled = (datasetPreferences === null || datasetPreferences === void 0 ? void 0 : datasetPreferences.showLastDesktopSyncInfo) !== false;
            setDatasetPreference({ showLastDesktopSyncInfo: !syncNoticeEnabled });
            return;
        }
        const changedCard = currentLayout.find((card) => card.key === cardId);
        if (!changedCard) {
            return;
        }
        changedCard.value = !changedCard.value;
        newList = (0, immutable_1.List)(currentLayout);
        setDatasetPreference({ overviewPageLayout: newList });
    };
    if (throwJSExceptionForTesting) {
        setTimeout(() => {
            throw new Error('Deliberate, uncaught JS exception for testing purposes');
        }, 3000);
    }
    if (throwREACTExceptionForTesting) {
        throw new Error('Deliberate, uncaught REACT exception for testing purposes');
    }
    // ----------------------------------------
    // build the layout into overviewData
    //
    const overviewData = [];
    const layout = overviewPageLayout;
    // This is a function that fills in space that is empty within the dashboard based on the mui grid sizing.
    layout.forEach((card) => {
        if (card.value) {
            overviewData.push(<ErrorBoundary_1.default key={`overviewCardKey: ${card.key}`}>
          <>
            {renderOverviewCard(card)}
          </>
        </ErrorBoundary_1.default>);
        }
    });
    // ----------------------------------------
    // build the configuration menu from config
    //
    const menuItems = [{
            label: 'Overview Cards',
            groupId: 'overviewCards',
            divider: true,
            isGroupList: true,
            groupList: [],
        }];
    const toFilter = [];
    if (!incomeEnabled) {
        toFilter.push('netIncome');
    }
    if (!spendingEnabled) {
        toFilter.push('spendingTime', 'spendingCats');
    }
    const availableLayout = (overviewPageLayout && overviewPageLayout.toJS());
    const overviewMenuGroup = [];
    if (canShowSyncNotice) {
        overviewMenuGroup.push({
            noCloseOnClick: true,
            selected: shouldShowSyncNotice,
            label: 'Last Desktop Sync Info',
            value: 'lastDesktopSyncInfo',
        });
    }
    menuItems[0].groupList = (_b = menuItems[0].groupList) === null || _b === void 0 ? void 0 : _b.concat(overviewMenuGroup).concat(availableLayout.map((layoutCard) => {
        const cardName = layoutCard.key;
        const card = config_1.overviewCards[cardName];
        return (card && { noCloseOnClick: true, selected: layoutCard.value, label: card.label, value: card.name });
    }));
    if (menuItems[0].groupList.length > 0) {
        menuItems[0].groupList[menuItems[0].groupList.length - 1].divider = true;
    }
    menuItems.push({ label: 'Reset to Default', value: 'resetDefaults' });
    // ----------------------------------------
    // Render it all
    //
    const renderLastSyncDate = () => (<div className={classes.syncNoticeWrapper}>
      <div className={(0, classnames_1.default)(classes.syncNotice, highlightSyncNotice && classes.syncNoticeHighlight)}>
        <span className={classes.syncNoticeText}>{`Last desktop sync: ${lastSyncLabel}`}</span>
        <Tooltip_1.default title={(<div className={classes.syncTooltip}>
              {highlightSyncNotice &&
                <div className={classes.syncTooltipTitle}>
                    It looks like your accounts haven&apos;t been synced in a while. 
                  </div>}
              <div className={classes.syncTooltipCopy}>
                To keep your Web and Mobile apps up to date, periodically go to your Quicken Desktop app and sync your accounts. 
                This ensures the most accurate and current information is available across all your devices
              </div>
            </div>)} placement="bottom-end" classes={{ tooltip: classes.syncTooltip }} enterDelay={200}>
          <IconButton_1.default aria-label="Desktop sync info" size="small" className={classes.syncInfoButton}>
            <InfoOutlined_1.default className={classes.syncInfoIcon}/>
          </IconButton_1.default>
        </Tooltip_1.default>
      </div>
    </div>);
    return (<ErrorBoundary_1.default className={classes.root}>
      <react_helmet_1.Helmet>
        <title>Dashboard</title>
      </react_helmet_1.Helmet>
      <div className={classes.appFrame}>
        <main className={classes.content}>
          <div className={classes.cardSpace}>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <Grid_1.default container spacing={2} justifyContent="flex-start" alignItems="flex-start" className={classes.gridStyle}>
              </Grid_1.default>
              <Grid_1.default container spacing={2} justifyContent="flex-start" alignItems="flex-start" className={classes.gridStyle}>
                {shouldShowSyncNotice && renderLastSyncDate()}
                {overviewData}
              </Grid_1.default>
            </div>
          </div>
          {(configureDash && !isEntityShareEnableUser) &&
            <div className={classes.configureDashboard}>
            <QMenu_1.default name="configdash" options={menuItems} onChange={onConfigChange} customTrigger="CONFIGURE DASHBOARD"/>
          </div>}
          <Footer_1.default isTablet={react_device_detect_1.isTablet}/>
        </main>
      </div>
    </ErrorBoundary_1.default>);
};
exports.default = OverviewPage;
